<template>
  <v-carousel 
    v-if="publicNewsList.length"
    ref="carousel" 
    id="carousel" 
    height="300px"
    cycle
    hide-delimiters
    show-arrows-on-hover 
    :show-arrows="publicNewsList.length > 1" 
  >
    <v-sheet color="primary">
      <v-carousel-item
        v-for="(item,i) in publicNewsList"
        :key="i"
        :src="item.imageName ? getNewsImgPath(item.imageName) : ''"
      >
        <v-row v-if="item.type === 'image-cover'" class="mt-0 fill-height">
          <v-col offset="1" cols="7" class="news-overlay-sheet align text-left">
            <v-row class="fill-height" align="center" justify="center"  >
              <v-col>
                <div class="news-overlay-content">
                  <h3 class="title white--text mb-1">
                    {{ item.title }}
                  </h3>
                  <h5 class="body-2" v-if="item.author">Par {{ item.author }}</h5>
                </div>
                <v-divider class="divider my-2"></v-divider>
                <p class="body-1">
                  {{ item.description }}
                </p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-carousel-item>
    </v-sheet>
  </v-carousel>
</template>

<script>
import MeService from '@/services/me'
import FilesPathHelpersMixin from '@/mixins/FilesPathHelpersMixin'
export default {
  name: 'NewsSlider',
  mixins: [FilesPathHelpersMixin],
  data: () => ({
    publicNewsList: [],
  }),
  computed: {
    carouselHeight () {
      // eslint-disable-next-line
      const breakpoint = this.$vuetify.breakpoint.name // Oui, cette ligne est juste présente pour servir de déclencheur :)

      const carousel = document.getElementById('carousel')
      return carousel ? ((200 * carousel.offsetWidth / 600) + 'px') : '200px'
    },
  },
  async created () {
    this.publicNewsList = await MeService.getPublicNews()
  }
}
</script>

<style>
.news-overlay-sheet {
  background: rgba(0, 0, 0, 0.6);
  /* height: 100%; */
}

.divider {
  border-color: rgb(255, 255, 255)!important;
}
</style>